"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function Contact() {
    return (react_1.default.createElement("div", { id: "contact" },
        react_1.default.createElement("div", { id: "join-us" },
            react_1.default.createElement("h1", null, "Want to join us?"),
            react_1.default.createElement("hr", null),
            react_1.default.createElement("p", null,
                "We are always looking for 8th graders to high schools seniors to participate in team activites. If you want to join the team, email ",
                react_1.default.createElement("a", { href: "mailto:fyre5480@gmail.com?subject=FYRE Robotics Interested Student" }, "the FYRE team email"),
                " or ",
                react_1.default.createElement("a", { href: "mailto:kerrythmpsn@gmail.com?subject=FYRE Robotics Interested Student" }, "Kerry Thompson"),
                "about the current season plans. We often have our season from December to May each year.")),
        react_1.default.createElement("div", { id: "sponsors" },
            react_1.default.createElement("h1", null, "Willing to sponsor us?"),
            react_1.default.createElement("hr", null),
            react_1.default.createElement("p", null,
                "If you want to contribute to the team, please reach out to ",
                react_1.default.createElement("a", { href: "mailto:fyre5480@gmail.com?subject=FYRE Sponsorship Interest" }, "FYRE 5480"),
                ". We are always appreciative of donations or sponsorships, as buying parts and traveling to competition can get expensive. Thank you so much!"),
            react_1.default.createElement("h3", null, "(Sponsors will be added to the website in the 2024 build season.)"))));
}
exports.default = Contact;
